import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { TextField } from '@mui/material';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import React, { useState } from 'react';
import Typography from '@mui/material/Typography';
import useStyles from './style';
import LoadingText from '../ReusableComponents/LoadingText/LoadingText';

export default function CodeInputTwoFactorAuth(props) {
  const { classes } = useStyles();

  const [code, setCode] = useState('');
  const [error, setError] = useState(null);

  const buildInfoText = () => {
    if (props.method.email) {
      return `We have sent a one-time code to your ${props.method.email} email address.
      Please check your mailbox to retrieve the code. Insert the code in the field below to finish logging in.`;
    }
    if (props.method.sms) {
      return `We have sent a one-time code to your ${props.method.sms} phone number.
      Please check your messages to retrieve the code. Insert the code in the field below to finish logging in.`;
    }
    if (props.method.call) {
      return `We will call you shortly at ${props.method.call} to communicate your one-time code to you.
      Insert the code in the field below to finish logging in.`;
    }
    return '';
  };

  return (
    <div className={classes.row}>
      <span className={classes.infoText}>{buildInfoText()}</span>
      <FormControl variant="standard" fullWidth className={classes.codeInput}>
        <FormLabel>Please enter the code</FormLabel>
        <TextField
          variant="standard"
          value={code}
          onChange={(e) => setCode(e.target.value)}
        />
      </FormControl>

      {error && (
        <Typography variant="body2" className={classes.error}>
          {error}
        </Typography>
      )}
      <div className={classes.actions}>
        <Button
          color="primary"
          variant="outlined"
          size="small"
          onClick={() => {
            setError(null);
            props.setCodeSent(false);
          }}
        >
          Re-Send Code
        </Button>
        <Button
          color="primary"
          variant="contained"
          size="small"
          onClick={() => props.verify(code, setError)}
        >
          {props.loading ? <LoadingText text="Verifying" /> : 'Submit'}
        </Button>
      </div>
      <br />
      <span>
        If you do not see the email within a few minutes, check your spam. If
        continue having trouble, please contact us at
        vendormasterdata@fashionnova.com
      </span>
    </div>
  );
}

CodeInputTwoFactorAuth.propTypes = {
  verify: PropTypes.func.isRequired,
  method: PropTypes.shape({
    email: PropTypes.string,
    sms: PropTypes.string,
    call: PropTypes.string,
  }).isRequired,
  setCodeSent: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};
